export default {
    preCheckIn: {
        checkIn: {
            title: 'Online Pre-Check In',
            info: 'Click the Continue button to proceed with Pre-Check In'
        },
        uploadPhoto: {
            title: 'Personal Information',
            formTitle: 'Upload or capture a clear photo of your government-issued ID',
            formSubtitle: '(Driver’s License, State ID, or Passport)',
            label: 'document',
            takePhoto: 'Take Photo',
            takeThisPhoto: 'Take This Photo',
            reTakePhoto: 'Retake Photo'
        },
        personalInfo: {
            title: 'Personal Information',
            formTitle: 'Verify your Personal Information',
            upload: 'Upload Photo',
            change: 'Change Photo'
        },
        insuranceData: {
            title: 'Insurance Data',
            question: 'Do you have active health insurance?',
        },
        insuranceCard: {
            title: 'Insurance Information',
            list: 'insurance list',
            description: {
                primary: ' is a health insurance plan that covers a person as an employee, subscriber, or member. Primary insurance is billed first when you receive health care. For example, health insurance you receive through your employer is typically your primary insurance.',
                secondary: ' is a health insurance plan that covers you in addition to your primary insurance plan. Typically, secondary insurance is billed when your primary insurance plan is exhausted and may help cover additional health care costs. For example, if you already have insurance through your employer and choose to enroll with your spouse’s health insurance plan (if allowed), that coverage would become your secondary insurance.',
                tertiary: ' is a health insurance plan that covers you in addition to your primary and secondary insurance plans. Typically, tertiary insurance is billed when your primary and secondary insurance plans are exhausted and may help cover additional health care costs.'
            },
            types: {
                primary: 'Primary',
                secondary: 'Secondary',
                tertiary: 'Tertiary',
            },
            confirmSwap: {
                start: 'Please confirm',
                end: 'is your {type} insurance',
            }
        },
        contactInfo: {
            title: 'Contact Information'
        },
        addressInfo: {
            title: 'Address',
            formTitle: 'Verify Address',
            notify: 'Address couldn\'t be recognized from the document.Please enter address manually'
        },
        emergencyContact: {
            title: 'Emergency Contact',
            formTitle: 'Emergency Contact Information',
            labels: {
                isMedical: 'My Emergency contact is my Medical decision maker',
                noEmergency: 'I don\'t have Emergency contact'
            }
        },
        medicalDecisionMaker: {
            title: 'Medical decision Maker',
            formTitle: 'Medical decision Maker Information',
            labels: {
                noMaker: 'I don\'t have Medical decision maker'
            }
        },
        primaryCarePhysician: {
            title: 'Primary Care Physician',
            formTitle: 'Primary Care Physician Information',
            skip: 'I don\'t have Primary Care Physician'
        },
        referringProvider: {
            title: 'Referring Provider',
            formTitle: 'Referring Provider Information',
            skip: 'I don\'t have Referring Provider'
        },
        questionnaire: {
            title: 'Questionnaire',
            data: 'questionnaire data'
        },
        signDocuments: {
            title: 'Sign Documents',
            formTitle: 'Review and sign the following documents to proceed',
            labels: {
                review: 'Documents are reviewed. Agree to sign.',
                signature: 'Provide your signature',
                doc: 'document to preview',
                list: 'list of documents',
                app: 'appointment data',
                insurance: 'insurance name',
                clinic: 'clinic name'
            },
        },
        thankYou: {
            header: 'Thank you',
            title: 'Thank you for completing Online Pre-Registration!',
            formTitle: 'Appointment Details',
            info: 'You have taken the first step towards better health with USA Pain Clinic.',
            call: 'If you need to contact us for any reason, please call',
            labels: {
                clinicName: 'clinic name',
                clinicData: 'clinic data'
            },
        },
    },
    components: {
        form: {
            accordionField: {
                defaultText: 'No insurance information',
                initText: 'Please add your {type} insurance',
                addText: 'Please add {type} insurance first',
            },
            insuranceBlock: {
                label: 'Insurance card',
                imageLabel: 'image',
            }
        },
        loginForm: {
            title: 'Provide your Date of Birth to login',
            errors: {
                date: 'Please enter a valid date'
            }
        },
        dobPicker: {
            months: {
                1: 'January',
                2: 'February',
                3: 'March',
                4: 'April',
                5: 'May',
                6: 'June',
                7: 'July',
                8: 'August',
                9: 'September',
                10: 'October',
                11: 'November',
                12: 'December'
            },
            labels: {
                day: 'Day',
                month: 'Month',
                year: 'Year'
            }
        }
    },
    form: {
        preUploader: {
            upload: 'Upload Image',
            newUpload: 'Upload New Image',
            error: 'We couldn\'t convert your photo',
            photoPlaceholder: "Center document in frame against a dark background"
        }
    },
    common: {
        errors: {
            fail: 'Oops, something went wrong',
            update: 'We couldn\'t update your {type}!',
            get: 'Can\'t get {type}!',
            getInfo: 'We couldn\'t get {type}!',
            save: 'We couldn\'t save your {type}!',
            saveDoc: 'We couldn\'t save {type} document!',
            saveAllDoc: 'We couldn\'t save all documents!',
            data: 'Can\'t get user data!',
            incorrectData: 'Please enter the correct data!',
            notRecognize: 'We couldn\'t recognize data from your {type}',
            ocr: 'Ocr data wasn\'t saved!',
            photo: 'Profile photo wasn\'t saved!',
            required: 'Required',
            doc: 'There aren\'t documents to sign!',
            app: 'No appointment!',
            signature: 'Signature can\'t be empty'
        },
        success: {
            photo: 'Profile photo is saved!'
        },
        buttons: {
            next: 'Continue',
            back: 'Back',
            signDoc: 'Sign the Documents',
            clear: 'Clear',
            done: 'Done',
            save: 'Save',
            edit: 'Edit',
            cancel: 'Cancel',
            confirm: 'Confirm',
            calendar: 'Add to calendar',
            setAs: 'Set as {type}',
        },
        labels: {
            firstName: 'First Name',
            lastName: 'Last Name',
            cellPhone: 'Phone',
            mobilePhone: 'Mobile Phone',
            homePhone: 'Home Phone',
            officePhone: 'Office phone',
            fax: 'Fax',
            email: 'Email',
            relation: 'Relationship',
            dob: 'Date of Birth',
            address: 'Street Address',
            street1: 'Street Address',
            apartment: 'Apartment/Suite #',
            city: 'City',
            state: 'State',
            zip: 'Zip',
            gender: 'Gender (optional)',
            planCode: 'Insurance',
            memberId: 'Member ID',
            male: 'Male',
            female: 'Female',
            yes: 'Yes',
            no: 'No',
            search: 'Searching',
            insurance: {
                name: 'Insurance',
                company: 'company',
                groupNumber: 'Group Number',
                startDate: 'Start Date',
                endDate: 'End Date',
                plan: 'Health Plan',
            },
            side: {
                front: {
                    name: 'front'
                },
                back: {
                    name: 'back'
                },
                title: 'Drag and drop the {side} side of your {type} here or',
                label: '{side} side of your {type}'
            },
            relations: {
                'Child': 'Child',
                'Spouse': 'Spouse',
                'Wife': 'Wife',
                'Husband': 'Husband',
                'Parent': 'Parent',
                'Self': 'Self',
                'Special Dependent': 'Special Dependent',
                'Employee': 'Employee',
                'Grandparent': 'Grandparent',
                'Aunt': 'Aunt',
                'Uncle': 'Uncle',
                'Grandchild': 'Grandchild',
                'Niece/Nephew': 'Niece/Nephew',
                'Organ Donor': 'Organ Donor',
                'Cadaver Donor': 'Cadaver Donor',
                'Life Partner': 'Life Partner',
                'Other': 'Other'
            }
        },
        rules: {
            valid: 'Please input a valid {field}',
            emptyPhoto: 'Please upload your {side} side image'
        }
    }
}
